/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guides_Path_P3Inputs */

const en_guides_path_p3 = /** @type {(inputs: Guides_Path_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If your files stopped fitting in memory, go straight to Working with Large JSON Files.
It is the only guide here that assumes the naive approach has already failed.`)
};

const ko_guides_path_p3 = /** @type {(inputs: Guides_Path_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파일이 메모리에 들어가지 않기 시작했다면 대용량 JSON 편으로 바로 가세요.
소박한 방법이 이미 실패했다고 전제하는 유일한 편입니다.`)
};

const ja_guides_path_p3 = /** @type {(inputs: Guides_Path_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルがメモリに収まらなくなっているなら、大容量JSON編に直接進んでください。
素朴な方法がすでに失敗していることを前提にしている唯一の編です。`)
};

/**
* | output |
* | --- |
* | "If your files stopped fitting in memory, go straight to Working with Large JSON Files. It is the only guide here that assumes the naive approach has already ..." |
*
* @param {Guides_Path_P3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guides_path_p3 = /** @type {((inputs?: Guides_Path_P3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guides_Path_P3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guides_path_p3(inputs)
	if (locale === "ko") return ko_guides_path_p3(inputs)
	return ja_guides_path_p3(inputs)
});